
import { OLMSApiService } from '@/shared/apis'
import { RootState } from '@/shared/store'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'

export type AddBreakPayload = {
  shiftId: EntityId
  stopId: EntityId | null
}

export const addBreak = createAsyncThunk<void, AddBreakPayload, { state: RootState }>(
  'shiftTable/addBreak',
  async ({ shiftId, stopId }, { getState }) => {
    const state = getState()
    const currentScreen = state.userInterface.currentScreen
    const endpoint = currentScreen === 'planning' ? '/planning/addBreak' : '/runsheet/addBreak'

    await OLMSApiService.post<null>(endpoint, {
      shiftId: shiftId,
      stopId: stopId,
    })
  },
)
